import React from 'react'
import AnchorLink from '../AnchorLink'

const DesktopScoreboard = ({
  title = '',
  textDescription = '',
  link = {
    text : '',
    href : '#'
  }
}) => {
  if(title === '' && textDescription === '') {
    return null
  }
  const target = { target: '_blank' }
  const DesktopScoreboardModule = (
    <article className="sub-module">
      <header className="bordered">
        <h1 key="h">{title}</h1>
      </header>
      <div className="content">
        <p>{textDescription}</p>
      </div>
      <footer>
        <AnchorLink classes="external" key="a" to={link.href} text={link.text} isRouterLink={false} {...target} />
      </footer>
    </article>
  )
  return DesktopScoreboardModule
}

export default DesktopScoreboard



// WEBPACK FOOTER //
// ../app/components/common/col-c/DesktopScoreboard.jsx